import api from './client';
import type { AxiosResponse } from 'axios';

export const registerUser = (data: Record<string, unknown>): Promise<AxiosResponse> => api.post('/auth/register', data);
export const loginUser = (data: { email: string; password: string }): Promise<AxiosResponse> => api.post('/auth/login', data);
export const quickLogin = (): Promise<AxiosResponse> => api.post('/auth/quick-login');
export const getMe = (): Promise<AxiosResponse> => api.get('/auth/me');
export const refreshToken = (): Promise<AxiosResponse> => api.post('/auth/refresh');
export const requestStepUpCode = (email: string): Promise<AxiosResponse> => api.post('/auth/step-up/request', { email });
export const verifyStepUpCode = (email: string, code: string, trustDeviceDays?: number): Promise<AxiosResponse> =>
  api.post('/auth/step-up/verify', {
    email,
    code,
    ...(trustDeviceDays && trustDeviceDays > 0 ? { trust_device_days: trustDeviceDays } : {}),
  });
export const acceptGdprConsent = (): Promise<AxiosResponse> => api.post('/auth/gdpr-consent', { accept: true });
